import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./index.css";

const elem = document.getElementById("root");
if (!elem) throw new Error("Root element #root not found in index.html");

if (import.meta.hot) {
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
} else {
  createRoot(elem).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
